import { MathUtils } from "three";
import { IComponentType, IActionCategory, ITriggerTypes } from "../component-data-structure";
export const getInitialEntityTransformValuesByIds = (input) => {
    const { ids, componentsById, transientScalesById, transientRotationsById, transientPositionsById } = input;
    if (!componentsById)
        return;
    return ids.map(id => {
        const component = componentsById[id];
        const [sx, sy, sz] = transientScalesById?.[id] ?? component.scale;
        const scale = [sx * 2, sy * 2, sz * 2];
        const [rx, ry, rz] = transientRotationsById?.[id] ?? component.rotation;
        const rotation = [MathUtils.degToRad(rx), MathUtils.degToRad(ry), MathUtils.degToRad(rz)];
        const position = component.type === IComponentType.Emitter ? [0, 0, 0] : transientPositionsById?.[id] ?? component.position;
        return {
            scale: [...scale],
            position: [...position],
            rotation: [...rotation]
        };
    });
};
export const getModelAndPresetAnimationControllerOptions = (actions, componentId) => {
    let presetAnimationOptions = [];
    let modelAnimationOptions = [];
    const triggers = Object.keys(actions || {});
    for (let i = 0; i < triggers.length; i++) {
        const trigger = triggers[i];
        const actionData = actions?.[trigger] || [];
        const presetAnimationData = actionData
            .filter(action => action.type === IActionCategory.animatePreset)
            .map(action => {
            const { type: _type, ...rest } = action;
            return { ...rest, componentId, triggerType: trigger };
        });
        const modelAnimationData = actionData
            .filter(action => action.type === IActionCategory.animateModel)
            .map(action => {
            const { type: _type, ...rest } = action;
            return { ...rest, componentId, triggerType: trigger };
        });
        modelAnimationOptions = [...modelAnimationOptions, ...(modelAnimationData ?? [])];
        presetAnimationOptions = [...presetAnimationOptions, ...(presetAnimationData ?? [])];
    }
    return { model: modelAnimationOptions, preset: presetAnimationOptions };
};
export const getAllOnloadModelAnimationPlayDataBySceneId = (componentsById, sceneId) => {
    const animationData = [];
    if (!componentsById)
        return animationData;
    const scene = componentsById[sceneId];
    const sceneActions = scene.actions;
    if (!sceneActions)
        return animationData;
    const onLoadActions = sceneActions[ITriggerTypes.onLoad];
    if (!onLoadActions)
        return animationData;
    for (let i = 0; i < onLoadActions.length; i++) {
        const action = onLoadActions[i];
        if (action.type !== IActionCategory.animateModel)
            continue;
        for (let j = 0; j < action.targetIds.length; j++) {
            const id = action.targetIds[j];
            animationData.push({
                id,
                isPlayingAnimation: true,
                animationName: action.animationName,
                animationRepetitions: action.animationRepetitions,
                isClampWhenFinished: action.isClampWhenFinished,
            });
        }
    }
    return animationData;
};
